module.exports = __webpack_public_path__ + "img/hero1.f4e5a59d.jpg";